import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "reason", "flag"]
  static values = {
    originalType: String,
    requiresCancellation: Boolean,
    openOnConnect: Boolean
  }

  connect() {
    this.onSubmit = this.onSubmit.bind(this)
    this.element.addEventListener("submit", this.onSubmit, true)

    if (this.openOnConnectValue) this.showModal()
  }

  disconnect() {
    this.element.removeEventListener("submit", this.onSubmit, true)
    document.body.classList.remove("overflow-hidden")
  }

  onSubmit(event) {
    if (!(event.target instanceof HTMLFormElement)) return
    if (this.confirming) return
    if (!this.requiresModal()) return

    event.preventDefault()
    event.stopImmediatePropagation()
    this.showModal()
  }

  confirm(event) {
    const reason = this.hasReasonTarget ? this.reasonTarget.value.trim() : ""
    if (!reason) {
      event.preventDefault()
      if (this.hasReasonTarget) {
        this.reasonTarget.required = true
        this.reasonTarget.reportValidity()
        this.reasonTarget.focus()
      }
      return
    }

    if (this.hasFlagTarget) this.flagTarget.value = "1"
    this.confirming = true
  }

  dismiss() {
    this.hideModal()
  }

  clickOutside(event) {
    if (event.target === event.currentTarget) this.dismiss()
  }

  requiresModal() {
    if (!this.requiresCancellationValue) return false
    if (this.originalTypeValue !== "normal") return false

    const selected = this.selectedAdmissionType()
    return Boolean(selected && selected !== "normal")
  }

  selectedAdmissionType() {
    const checked = this.element.querySelector('input[name="patient[admission_type]"]:checked')
    return checked?.value
  }

  showModal() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    if (this.hasReasonTarget) this.reasonTarget.focus()
  }

  hideModal() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    if (this.hasReasonTarget) this.reasonTarget.required = false
  }
}
